var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.091 85.072 H 21.909 c -1.657 0 -3 -1.343 -3 -3 c 0 -19.087 8.483 -26.361 15.299 -32.206 l 1.142 -0.982 c 1.19 -1.031 1.845 -2.38 1.845 -3.798 c 0 -1.417 -0.655 -2.766 -1.846 -3.797 l -1.142 -0.983 C 27.391 34.461 18.909 27.187 18.909 8.1 c 0 -1.657 1.343 -3 3 -3 h 46.182 c 1.657 0 3 1.343 3 3 c 0 19.087 -8.482 26.361 -15.298 32.207 l -1.142 0.982 c 0 0 0 0 0 0 c -1.19 1.031 -1.846 2.379 -1.846 3.797 c -0.001 1.418 0.655 2.767 1.846 3.798 l 1.141 0.982 c 6.816 5.845 15.299 13.118 15.299 32.206 C 71.091 83.729 69.748 85.072 68.091 85.072 z M 24.989 79.072 h 40.022 c -0.776 -14.063 -7.047 -19.44 -13.124 -24.651 l -1.165 -1.002 c -2.525 -2.189 -3.917 -5.148 -3.916 -8.333 c 0 -3.185 1.391 -6.144 3.916 -8.332 v 0 l 1.165 -1.002 c 6.077 -5.211 12.348 -10.59 13.124 -24.652 H 24.989 c 0.776 14.062 7.047 19.439 13.124 24.651 l 1.166 1.003 c 2.525 2.188 3.916 5.147 3.916 8.332 s -1.391 6.144 -3.916 8.332 l -1.166 1.003 C 32.036 59.633 25.765 65.011 24.989 79.072 z M 52.687 39.021 h 0.01 H 52.687 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.921 90 H 18.08 c -0.857 0 -1.552 -0.695 -1.552 -1.552 v -6.376 c 0 -0.857 0.695 -1.552 1.552 -1.552 h 53.841 c 0.857 0 1.552 0.695 1.552 1.552 v 6.376 C 73.473 89.305 72.777 90 71.921 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.921 9.479 H 18.08 c -0.857 0 -1.552 -0.695 -1.552 -1.552 V 1.552 C 16.528 0.695 17.223 0 18.08 0 h 53.841 c 0.857 0 1.552 0.695 1.552 1.552 v 6.376 C 73.473 8.785 72.777 9.479 71.921 9.479 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.8849316a.svg";
export { ForwardRef as ReactComponent };